import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DashboardFilterName, DashboardFilterValues } from '@vi-iot/client';
import { CustomTranslationsService } from 'src/app/operational-data-common/translations';

@Pipe({
  name: 'dashboardFilterTranslation',
  standalone: true,
})
export class DashboardFilterTranslationPipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private customTranslationsService: CustomTranslationsService
  ) {}

  /**
   *
   * @param input Value used in mapping
   * @param filterName Additional key, introduced for anomalies to catch them and use translations from Remote Service
   */
  transform(input: DashboardFilterValues | string, filterName?: DashboardFilterName): string {
    if (filterName === DashboardFilterName.AnomaliesNames) {
      const translation = this.customTranslationsService.ANOMALIES_NAMES[input];

      return translation ? this.translateService.instant(translation) : input;
    }

    switch (input) {
      case 'critical':
        return this.translateService.instant('+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.CRITICAL');
      case 'warning':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.ACTIVE_ANOMALIES'
        );
      case 'information':
        return this.translateService.instant('+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.INFORMATION');
      case 'active-smartnote':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.ACTIVE_SMARTNOTE'
        );
      case 'aggregated-status':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.AGGREGATED_STATUS'
        );
      case 'balanced':
        return this.translateService.instant('+INSTALLATIONS.INSTALLATION.HEATING.DHW.BALANCED');
      case 'off':
        return this.translateService.instant('+INSTALLATIONS.INSTALLATION.HEATING.DHW.OFF');
      case 'comfort':
        return this.translateService.instant('+INSTALLATIONS.INSTALLATION.HEATING.DHW.COMFORT');
      case 'eco':
        return this.translateService.instant('+INSTALLATIONS.INSTALLATION.HEATING.DHW.ECO');
      case 'heating':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.HEATING'
        );
      case 'standby':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_MODE.STANDBY'
        );
      case 'auto':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.HEATING_AND_COOLING'
        );
      case 'cooling':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.COOLING'
        );
      case 'heatingCooling':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.HEATING_AND_COOLING'
        );
      case 'dhw':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_MODE.DHW'
        );
      case 'dhwAndHeatingCooling':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.DHW_HEATING_AND_COOLING'
        );
      case 'Pro':
        return this.translateService.instant('+BOOKING.PLAN.PRO_PACKAGE');
      case 'Free':
        return this.translateService.instant('+BOOKING.PLAN.FREE_PACKAGE');
      case 'Residential':
        return this.translateService.instant('+INSTALLATIONS.INSTALLATIONS.DASHBOARD.RESIDENTIAL');
      case 'hems-activated':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.HEMS_ACTIVATED'
        );
      case 'src-activated':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.SRC_ACTIVATED'
        );
      case 'dhw-operating-mode':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.DHW_ACTIVE_OPERATING_MODE'
        );
      case 'heating-operating-mode':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.DHW_OPERATING_MODE'
        );
      case 'paid-package':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.PAID_PACKAGE'
        );
      case 'installation-type':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.INSTALLATION_TYPE'
        );
      case 'product-name':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.PRODUCT_NAME'
        );
      case 'active-anomalies':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.ACTIVE_ANOMALIES'
        );
      case 'Error':
        return this.translateService.instant('+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.FAULT');
      case 'Maintenance':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.MAINTENANCE'
        );
      case 'WorksProperly':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.WORKS_PROPERLY'
        );
      case 'RemoteDiagnosticSession':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.REMOTE_DIAGNOSTICS_SESSION'
        );
      case 'NbIotConnected':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.NBIOT_CONNECTED'
        );
      case 'anomalies-names':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.ANOMALIES_NAMES'
        );
      case 'efficient':
        return this.translateService.instant('+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.EFFICIENT');
      case 'efficientWithMinComfort':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.EFFICIENT_WITH_MIN_COMFORT'
        );
      case 'dhwAndHeating':
        return this.translateService.instant(
          '+INSTALLATIONS.KANBAN_DASHBOARD.FILTERS.DHW_AND_HEATING'
        );
      case 'forcedNormal':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.FORCED_NORMAL'
        );
      case 'forcedReduced':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.FORCED_REDUCED'
        );
      case 'hems-not-activated':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.HEMS_NOT_ACTIVATED'
        );
      case 'src-not-activated':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.OPERATING_MODE.SRC_NOT_ACTIVATED'
        );

      case 'without-standalone-installations':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.WITHOUT_STANDALONE_INSTALLATIONS'
        );

      case 'with-standalone-installations':
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.CIRCUIT.WITH_STANDALONE_INSTALLATIONS'
        );

      default:
        return input;
    }
  }
}
